import request from './axios'

export default {
  // 获取所有资源数据
  getResources() {
    return request.get('/api/resources')
  }
}